export default [
    {
        path: '/terms',
        name: 'terms',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "temms" */ '../views/TermsPage.vue')
    },

    {
        path: '/help',
        name: 'help',
        component: () => import(/* webpackChunkName: "help" */ '../views/FaqPage.vue')
    },
]

